import { DateTime } from 'luxon';

const ZONE = { zone: 'Australia/Adelaide' };

export const getSouthAusDateTime = () => {
    if (!window.w) {
        window.w = DateTime;
    }
    const localDateTime = DateTime.now().toISO();
    const southAusDateTime = DateTime.fromISO(localDateTime, ZONE);
    // console.log(southAusDateTime.toFormat('HH:mm:ss'));
    return southAusDateTime;
};

// Formats dates for API calls
export const apiDateString = (southAusDateTime, when) => {
    console.log(southAusDateTime);
    switch (when) {
        case '6 months from now':
            return southAusDateTime.plus({ months: 6 }).toFormat('yyyy-MM-dd');

        default:
            // Today
            return southAusDateTime.toFormat('yyyy-MM-dd');
    }
};

// Accepts either JS Date or ISO String and outputs date string , default format '30/2/22'
export const toDateString = (date, format = 'd/M/yy') => {
    if (date instanceof Date) return DateTime.fromJSDate(date, ZONE).toFormat(format);
    if (typeof date === 'string') return DateTime.fromISO(date, ZONE).toFormat(format);
};

// Formats time strings from API: 10:00:00 -> 10.00am'
export const toTimeString = (string) => {
    return DateTime.fromFormat(string, 'HH:mm:ss').toFormat('h.mma').toLocaleLowerCase();
};

// Check if ISO  datetime is in the past or less than 2 hours from now (inelgible for booking)
export const laterThanTwoHoursFromNow = (iso, southAusDateTime) => {
    return southAusDateTime.plus({ hours: 2 }) >= DateTime.fromISO(iso, ZONE);
};

export const withinRange = (queryDate, rangeStart, rangeEnd, format = 'yyyy-MM-dd') => {
    const start = DateTime.fromFormat(rangeStart, format);
    const end = DateTime.fromFormat(rangeEnd, format);
    const query = DateTime.fromFormat(queryDate, format);
    return query >= start && query <= end;
};

export const googleCalDate = (iso) => {
    return DateTime.fromISO(iso, ZONE).toUTC().toString().replace(/[:-]/gi, '');
};

export const weekdays = [
    { label: 'Monday', value: 'mon' },
    { label: 'Tuesday', value: 'tue' },
    { label: 'Wednesday', value: 'wed' },
    { label: 'Thursday', value: 'thu' },
    { label: 'Friday', value: 'fri' },
    { label: 'Saturday', value: 'sat' }
];
